{
    "walk-one-hour": "Walk",
    "your-family": "Those You Love",
    "miles-to-the-border": "km",
    "you": "you",
    "wife": "wife",
    "son": "son",
    "daughter": "daughter",
    "day": "day",
    "daylight": "daylight",
    "strength": "Strength",
    "speak": "Speak",
    "stealth": "Stealth",
    "exploration": "Exploration",
    "bag-is-empty": "Bag is empty"
}